import { useState } from "react";
import { Search } from "lucide-react";
import { useMenu } from "@/menu/MenuApp";
import { loc } from "@/menu/i18n";
import { DishCard } from "@/menu/CategoryPage";

const SearchPage = () => {
  const { data, lang, t } = useMenu();
  const [q, setQ] = useState("");

  const query = q.trim().toLowerCase();
  const results = query
    ? data.dishes.filter((d) => {
        const cat = data.categories.find((c) => c.id === d.category_id);
        if (cat?.available === false) return false;
        return [loc(d.name, "it"), loc(d.name, "en"), loc(d.description, "it"), loc(d.description, "en"), cat ? loc(cat.name, "it") : "", cat ? loc(cat.name, "en") : ""]
          .join(" ").toLowerCase().includes(query);
      })
    : [];

  return (
    <div data-testid="menu-search-page" className="mx-auto max-w-3xl px-5 py-12">
      <h1 className="font-display text-4xl font-semibold tracking-tight">{t("search")}</h1>
      <div className="relative mt-8">
        <Search size={17} className="absolute left-0 top-1/2 -translate-y-1/2 text-[#C19D60]" strokeWidth={1.4} />
        <input
          data-testid="menu-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("searchPh")}
          autoFocus
          className="w-full border-b border-[#C19D60]/30 bg-transparent py-4 pl-8 text-base font-light text-[#F8F5F0] outline-none transition-colors placeholder:text-[#666] focus:border-[#C19D60]"
        />
      </div>
      {query && (
        <p className="mt-8 text-[11px] uppercase tracking-[0.3em] text-[#C19D60]" data-testid="menu-search-count">
          {t("searchResults")} “{q}” — {results.length}
        </p>
      )}
      <div className="mt-6 space-y-3.5" data-testid="menu-search-results">
        {query && results.map((d, i) => <DishCard key={d.id} dish={d} index={i} allergens={data.allergens} lang={lang} t={t} />)}
        {query && results.length === 0 && <p className="py-10 text-center text-sm font-light text-[#A3A3A3]">{t("noResults")}</p>}
      </div>
    </div>
  );
};

export default SearchPage;
